(ns ui.view.card.model
  (:require
   [clojure.string :as string]
   [common.util :as cu]))

(def EntityID [:or :int :string])
(def EntityField :keyword)


  ;; TODO this is in progress
(def CardStateSchema
  [:map
   [:initial-data-loaded? :boolean]
   [:loading? :boolean]
   [:loading-error? :boolean]
   [:full-screen? :boolean]

   [:entities {:optional true}
    [:map-of EntityID map?]]

   [:entity-edits {:optional true}
    [:map-of EntityID [:map-of EntityField :any]]]

   [:entity-updates {:optional true}
    [:map-of EntityID map?]]])

(def loading-error-path [:loading-error?])

(defn loading-error-full-path
  [card-state-path]
  (into card-state-path loading-error-path))

(defn ->card-loading-error-path
  [card-state-path]
  (conj card-state-path :loading-error?))

(def full-screen-path [:full-screen?])

(defn full-screen-full-path
  [card-state-path]
  (into card-state-path full-screen-path))

(def entities-path [:entities])

(defn entities-full-path
  [card-state-path]
  (into card-state-path entities-path))

(def initial-data-loaded-path [:initial-data-loaded?])

(defn initial-data-loaded-full-path
  [card-state-path]
  (into card-state-path initial-data-loaded-path))

(def entity-peek-path [:entity-peek])

(defn entity-peek-full-path
  [card-state-path]
  (into card-state-path entity-peek-path))

;; TODO: Decide if these paths should be always relative to the 
;; current component state root, or if the paths should effectively be keys

(def entity-peek-open-path (conj entity-peek-path :open?))

(defn entity-peek-open-full-path
  [card-state-path]
  (into card-state-path entity-peek-open-path))

(def entity-peek-entity-id-path (conj entity-peek-path :entity-id))

(defn entity-peek-entity-id-full-path
  [card-state-path]
  (into card-state-path entity-peek-entity-id-path))

(def entity-peek-opened-at-path (conj entity-peek-path :opened-at))

(defn entity-peek-opened-at-full-path
  [card-state-path]
  (into card-state-path entity-peek-opened-at-path))

(def delete-confirmation-entity-id-path [:delete-confirmation-entity-id])

(defn ->ws-subscription-key
  [card-state-path]
  (->> card-state-path
       (mapv (fn [path-part]
               (if (keyword? path-part)
                 (cu/kw->str path-part)
                 (str path-part))))
       (string/join "-")
       keyword))

;; TODO: Move to common namespace and add more card type specific configurations
(defn create-initial-card-state
  [{:keys [card show-realtime-updates?]}]
  (let [card-type (:card/type card)]
    (merge
     {:loading? true
      :loading-error? false
      :full-screen? false
      :show-realtime-updates? show-realtime-updates?
      :initial-data-loaded? false}
     (when (= card-type :card.type/activities)
       {:loading-emails? true
        :loading-emails-error? false
        :loading-activities? true
        :loading-activites-error? false}))))

(defn get-entities
  [db card-state-path]
  (get-in db (entities-full-path card-state-path)))

(defn get-entity
  [db card-state-path entity-id]
  (let [entities (get-entities db card-state-path)]
    (get entities entity-id)))

(defn get-primary-entity
  [db {:keys [entity-id card-state-path] :as _ctx}]
  (let [entities (get-entities db card-state-path)]
    (get entities entity-id)))

(defn set-full-screen
  [db card-state-path full-screen?]
  (assoc-in db (full-screen-full-path card-state-path) full-screen?))

(defn toggle-full-screen
  [db card-state-path]
  (let [prev-value (get-in db (full-screen-full-path card-state-path))
        new-value (not prev-value)]
    (set-full-screen db card-state-path new-value)))

(defn set-loading-error
  [db card-state-path loading-error?]
  (assoc-in db (->card-loading-error-path card-state-path) loading-error?))

(defn reset-entities
  [db card-state-path entities-by-id]
  (assoc-in db (entities-full-path card-state-path) entities-by-id))

(defn merge-entities
  [db card-state-path entities-by-id]
  (update-in db (entities-full-path card-state-path) merge entities-by-id))

(defn remove-entities
  [db card-state-path entity-ids-to-remove]
  (let [path (entities-full-path card-state-path)]
    (update-in db path (partial apply dissoc) entity-ids-to-remove)))
